var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "arrow_svg__a",
    d: "M6.37 9.27L.858 12.52V9.764l1.924-1.131L.858 7.398V4.772L6.37 8.126z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -4)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrow_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrow_svg__a"
  }))));
};
export default SvgArrow;